import * as React from 'react';
import { take } from 'lodash';
import styled from 'styled-components';
import cl from 'classnames';

import { flexGap } from '@doltech/utils/lib/css-style';
import { colorsV2 } from '@doltech/ui/lib/figma/colors-v2';
import { UserAvatarMore } from '@doltech/ui/lib/figma/User/UserAvatarMore/UserAvatarMore';
import { UserAvatar } from '@doltech/ui/lib/figma/User/UserAvatar/UserAvatar';

const BORDER_WIDTH = 2;
const OVARLAP_RATIO = 1 / 7;

const Avatar = styled.div`
  border-radius: 50%;
  outline: ${BORDER_WIDTH}px solid ${colorsV2.white100};
`;

const Container = styled.div<{ avatarSize?: number }>`
  display: flex;

  ${Avatar} {
    &:not(:first-child) {
      margin-left: -${(p) => p.avatarSize * OVARLAP_RATIO}px;
    }
  }

  &.separate {
    ${flexGap(8)}
    ${Avatar} {
      margin-left: 0;
    }
  }
`;

export interface UserModel {
  id?: string | number;
  userId?: string;
  name?: string;
  email?: string;
  avatarUrl?: string;
}

interface AvatarMultiProps {
  users: UserModel[];
  avatarSize?: number;
  maxCount?: number;
  separate?: boolean;
  seeMoreType?: 'more' | 'number-plus' | 'none';
  onSeeMore?: () => void;
}

export const AvatarMultiGrammar = (props: AvatarMultiProps) => {
  const {
    users = [],
    maxCount = 3,
    avatarSize = 20,
    separate = false,
    seeMoreType = 'more',
    onSeeMore,
  } = props;
  return (
    <Container className={cl('avatar-multi', { separate })} avatarSize={avatarSize}>
      {take(users, maxCount).map(({ userId, id, name, email, avatarUrl }, index) => {
        return (
          <Avatar key={`${id}${index}${userId}`}>
            <UserAvatar
              layout="default"
              userName={name || userId}
              userAvatar={avatarUrl}
              size={avatarSize}
            />
          </Avatar>
        );
      })}
      {users?.length > maxCount && seeMoreType !== 'none' && (
        <UserAvatarMore
          type={seeMoreType}
          size={avatarSize}
          totalMore={users?.length - maxCount}
          onClick={onSeeMore}
        />
      )}
    </Container>
  );
};
